// extracted by mini-css-extract-plugin
export var container = "styles-module--container--950fb";
export var video = "styles-module--video--f8635";